import React from 'react';

import NewWorkspacePanel from '../shared/NewWorkspacePanel';
import SettingsBackButton from '../shared/SettingsBackButton';
import { SETTINGS_MODAL_TITLE_CLASS } from '../shared/settingsModalChrome';
import { Modal } from './Modal';
import { ModalBody } from './ModalBody';
import { ModalContent } from './ModalContent';
import { ModalTopBar } from './ModalTopBar';

// Same chrome and scaffolding as the settings modals (WorkspaceOptionsModal's
// nested pages): floating SettingsBackButton, pinned ModalTopBar, ModalContent
// as the scroller. The Create pill floats at top-right from inside the panel so
// it can share the form's state.
const NewWorkspaceModal = ({
  onClose,
  onWorkspaceCreated,
  workspaceUrlForWorkspace,
  libraryWorkspaceId = null,
  libraryDirectMessageId = null,
}) => {
  return (
    <Modal onClose={onClose} className="rounded-2xl" showClose={false}>
      <SettingsBackButton onClick={onClose} />
      <ModalBody className="h-full">
        <ModalTopBar className="!pb-0">
          <span className={SETTINGS_MODAL_TITLE_CLASS}>Create a Space</span>
        </ModalTopBar>
        <ModalContent className="min-h-0 md:!px-5">
          <NewWorkspacePanel
            onWorkspaceCreated={onWorkspaceCreated}
            workspaceUrlForWorkspace={workspaceUrlForWorkspace}
            libraryWorkspaceId={libraryWorkspaceId}
            libraryDirectMessageId={libraryDirectMessageId}
          />
        </ModalContent>
      </ModalBody>
    </Modal>
  );
};

export default NewWorkspaceModal;
